import styled from "styled-components"

const STATUS_COLORS = {
    passed: {
        color: '#16a34a',
        background: 'rgba(22, 163, 74, 0.12)',
    },
    manual_review: {
        color: '#d97706',
        background: 'rgba(217, 119, 6, 0.12)',
    },
    resubmission_required: {
        color: '#ea580c',
        background: 'rgba(234, 88, 12, 0.12)',
    },
    pending: {
        color: '#2563eb',
        background: 'rgba(37, 99, 235, 0.12)',
    },
    failed: {
        color: '#dc2626',
        background: 'rgba(220, 38, 38, 0.12)',
    },
}

export const FiatAccStatusBadge = styled.div`
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;

  color: ${({ status }) => STATUS_COLORS[status]?.color || '#6b7280'};
  background-color: ${({ status }) =>
        STATUS_COLORS[status]?.background || 'rgba(107, 114, 128, 0.12)'};
`